/**
 * Single source of truth for DoneGrading's canonical production app URL.
 *
 * Users should only ever see and use https://app.donegrading.com — never the
 * App Hosting backend default domain (…hosted.app) and never a Firebase
 * default domain. Use these constants for any production-facing app link
 * (emails, deep links, share URLs, App/Universal Links).
 *
 * Runtime origins (e.g. OAuth redirect_uri, API base) intentionally keep using
 * `window.location.origin` so localhost development continues to work — this
 * constant is for production-facing, user-visible links only.
 */
export const CANONICAL_APP_HOST = 'app.donegrading.com';

export const CANONICAL_APP_URL = `https://${CANONICAL_APP_HOST}`;
